import React from 'react';

function ViewCommission({ user, closeModal }) {
  if (!user) return null;

  const formatDate = (dateStr) => {
    if (!dateStr) return "N/A";
    const date = new Date(dateStr);
    return date.toLocaleDateString();
  };
  return (
    <div className="modal fade viewbox edit-box show d-block">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Commission Details</h5>
            <button className="btn-close" onClick={closeModal}></button>
          </div>
          <div className="modal-body px-5">
            <div className="d-box mt-3 pt-1">
                 <ul className="d-flex list-unstyled justify-content-between">
              <li >
                <strong>Seller:</strong>{" "}
                {user?.sellerId
                  ? `${user.sellerId.firstName} ${user.sellerId.lastName}`
                  : "N/A"}
              </li>

              <li >
                <strong>Category:</strong>{" "}
                {user?.categoryId?.name || "N/A"}
              </li>
              <li >
                <strong>Service:</strong>{" "}
                {user?.serviceId.title|| "N/A"}
                
              </li>
              {/* Amount */}
              <li >
                <strong>Amount:</strong> ₹ {user?.amount || "0"}
              </li>
              {/* Created Date */}
              <li >
                <strong>Created At:</strong> {formatDate(user?.createdAt)}
              </li>
            </ul>
            </div>
         

          </div>

        </div>
      </div>
    </div>
  );
}

export default ViewCommission;